// KilatDomain operators' own shapes, shared by the API's identity/staff and the staff SPA:
// inviting, listing and disabling staff. A field renamed here fails both typechecks.
import { z } from "zod";

/** The staff vocabulary (apps/api identity/staff/access.ts); the database CHECK reads the same list. */
export const STAFF_ROLES = ["support", "finance", "compliance", "superadmin"] as const;
export const StaffRole = z.enum(STAFF_ROLES);
export type StaffRole = z.infer<typeof StaffRole>;

/** Two states, so no machine: disabled staff come back only by a fresh invitation. */
export const STAFF_STATUSES = ["active", "disabled"] as const;
export const StaffStatus = z.enum(STAFF_STATUSES);
export type StaffStatus = z.infer<typeof StaffStatus>;

/** A key on the wire: 22 Base62 characters, never a raw UUID (screaming.md rule 19). */
const Base62Id = z.string().regex(/^[0-9A-Za-z]{22}$/);

// No password: the invitee sets one from the emailed link, then enrols TOTP.
export const InviteStaffRequest = z.object({
  email: z.email().max(254),
  name: z.string().trim().min(1).max(100),
  role: StaffRole,
});
export type InviteStaffRequest = z.infer<typeof InviteStaffRequest>;

export const StaffMember = z.object({
  id: Base62Id,
  email: z.string(),
  name: z.string(),
  role: StaffRole,
  status: StaffStatus,
  /** Whether they have enrolled TOTP; until then they cannot use the staff area. */
  enrolled: z.boolean(),
  createdAt: z.iso.datetime(),
});
export type StaffMember = z.infer<typeof StaffMember>;

export const ListStaffResponse = z.object({ data: z.array(StaffMember) });
export const StaffMemberResponse = z.object({ data: StaffMember });
